import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'lib-account-details-icon',
  templateUrl: './lib-account-details-icon.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class LibAccountDetailsIconComponent implements OnInit {
  constructor() {}

  ngOnInit(): void {}
}
